import styled from "styled-components";

export const Input = styled.input`
  margin: 11px 0; 
  min-width: 300px;
  padding:5px;
  &:focus{
    border-color:rgba(36,144,255,0.55);
  } 
`;
